import {
  Sky500,
  TrelloBlue500,
  Yellow500,
  Red500,
  Purple500,
  Pink500,
  Green500,
  Orange500,
  Lime500,
  N900,
} from '@trello/colors';

export const LabelColorMap: Record<string, string> = {
  green: Green500,
  red: Red500,
  yellow: Yellow500,
  blue: TrelloBlue500,
  sky: Sky500,
  purple: Purple500,
  pink: Pink500,
  orange: Orange500,
  lime: Lime500,
  black: N900,
};
